import {Controller} from '@hotwired/stimulus'
import CookieLanguageHelper from '../helpers/cookie_language_helper'

export default class extends Controller {
    static targets = ['table']

    connect() {
        this.dt = $(this.tableTarget).DataTable({
            language: {url: CookieLanguageHelper.getTableTranslationFile()},
            paging: false,
            searching: false,
            info: false,
            columnDefs: [
                {orderSequence: ['desc', 'asc'], targets: '_all'},
                {type: 'num', targets: 4},
                {type: 'numeric-comma', targets: 5}
            ]
        });
    }

    disconnect() {
        this.dt.destroy();
    }
}
